/**
 * This directive manages focus on items which can be removed from the DOM and are in a ng-repeat.
 * Focus will move to the next item in the list, or previous if there is no next item.
 * if there are no more items in the list, then move to the parent.
 *
 * Works best when tracking changes of the ng-repeat is optimized by a "track by" expression.
 */
module.exports = function (moveFocus) {
    return function (scope, element) {
        scope.$on('$destroy', () => {
            const $parent = element.parent();
            const $elemNext = element.next();
            const $elemToFocus = $elemNext.length && element[0].nodeName === $elemNext[0].nodeName ? $elemNext : element.prev();

            // move focus if element to focus is the same as this, or move to parent element.
            moveFocus($elemToFocus.length && element[0].nodeName === $elemToFocus[0].nodeName ? $elemToFocus : $parent);
        });
    };
};



// WEBPACK FOOTER //
// ./src/olycommon/movefocus/movefocus-afterdelete.directive.js